module.exports = __webpack_public_path__ + "static/media/connect.3284a50f.png";